/** @format */
import { MediaQuery } from '@mpb-com/feather/helpers/media-queries';
import React, { useContext, useState } from 'react';

import { ApplicationContext } from '@toucan/client/global/application';

import { ProductComparisonDisplay } from '@toucan/client/features/model/components/model-overview/hooks/use-product-comparison/components/product-comparison-display';
import { CurrentProduct } from '@toucan/client/features/model/components/model-overview/hooks/use-product-comparison/config/types';

export const useProductComparison = () => {
    const { openDrawer } = useContext(ApplicationContext);
    const [productIds, setProductIds] = useState<number[]>([]);
    const [currentProduct, setCurrentProduct] = useState<CurrentProduct>();

    const setProductComparison = (
        productIds: number[],
        currentProduct?: CurrentProduct
    ) => {
        setProductIds(productIds);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- Legacy code: do not use as an example.
        currentProduct && setCurrentProduct(currentProduct);
    };

    const showProductComparison = () => {
        if (!currentProduct) {
            return;
        }

        openDrawer({
            children: (
                <ProductComparisonDisplay
                    productIds={productIds}
                    currentProduct={currentProduct}
                />
            ),
            fullWidth: MediaQuery.LARGE_TABLET,
            verticalContentPadding: false,
        });
    };

    return {
        setProductComparison,
        showProductComparison,
    };
};
